<template>
	<div id="appraisalinvoice-editor"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="loading_view" v-if="selecting_line">
				<div class="dialog_container">
					<div>
						<span>{{ $t('Select_Real_estate_to_be_added') }} {{ $t('or') }} <span class="navspan"
																							  @click.prevent="onCreateNewLine()">{{ $t('create_a_new_one')
							}}</span></span>
					</div>
					<br>
					<div class="field-container">
						<div class="ms-container">
							<label class="field__group__label">{{ $t('Existing_Real_estates')
								}}</label>
							<multiselect placeholder=""
										 :value="importLineValue"
										 :options="object_to_array(lines)"
										 track-by="id"
										 :label="'full_address'"
										 :searchable="true"
										 v-model="appraisalinvoice.importLine"
										 @input="set_import_line"></multiselect>
						</div>
					</div>
					<table class="dialog_buttons_table">
						<tr>
							<td>
								<div>
									<div @click.prevent="onCancelImportNewLine"
										 style="width: fit-content; margin-right: auto">
										<icon-button icon="times" :text="''"
													 icon_color="black"
													 text_color="black" border_color="lightgray" min_width="80px"
													 max_width="80px"></icon-button>
									</div>
								</div>
							</td>
							<td>
								<div>
									<div @click.prevent="onImportNewLine({id: appraisalinvoice.importLine.id})"
										 style="width: fit-content; margin-left: auto">
										<icon-button icon="check" :text="''"
													 icon_color="black"
													 text_color="black" border_color="lightgray" min_width="80px"
													 max_width="80px"></icon-button>
									</div>
								</div>
							</td>
						</tr>
					</table>

				</div>
			</div>

			<div class="loading_view" v-if="creating_contact">
				<div class="dialog_container">
					<div>
						<span>{{ $t('Create_new_contact') }}</span>
					</div>
					<br>
					<div class="form-section">
						<!--<h3>{{ $t('Person_type') }}</h3>-->
						<div class="field-container">

							<div class="ms-container">
								<label class="field__group__label">{{ $t('Person_type') }}</label>
								<multiselect placeholder=""
											 :value="value"
											 :options="personTypeOptions"
											 track-by="id"
											 :label="(currentLocale === 'ca')?
											 'name_ca': (currentLocale === 'en')?
											 'name_en': 'name_es'"
											 :searchable="false"
											 v-model="contact.person_type"
											 @input="set_contact_person_type"></multiselect>
							</div>
						</div>

						<div v-if="contact.person_type">

							<!--<h3>{{ $t('Data') }}</h3>-->
							<div class="field-container">
								<div class="ms-container" v-if="contact.person_type.id === 1">
									<label class="field__group__label">{{ $t('Title') }}</label>
									<multiselect placeholder=""
												 :value="value"
												 :options="honorificTitleOptions"
												 track-by="id"
												 :label="(currentLocale === 'ca')?
											 'abb_ca': (currentLocale === 'en')?
											 'abb_en': 'abb_es'"
												 :searchable="false"
												 v-model="contact.title"
												 @input="set_contact_title"></multiselect>
								</div>
								<div class="field__group">
									<label class="field__group__label">{{ $t('Name') }}</label>
									<input class="field__group__input"
										   type="text"
										   spellcheck="false"
										   v-model="contact.name"
										   @input="set_contact_name">
								</div>
							</div>
							<div class="field-container">

								<div class="field__group" v-if="contact.person_type.id === 1">
									<label class="field__group__label">{{ $t('Surnames') }}</label>
									<input class="field__group__input"
										   type="text"
										   spellcheck="false"
										   v-model="contact.surnames"
										   @input="set_contact_surnames">
								</div>


								<!--
								<div class="field__group">
									<label class="field__group__label">{{ $t('Main_email') }}</label>
									<input class="field__group__input"
										   type="text"
										   spellcheck="false"
										   v-model="contact.main_email"
										   @input="set_contact_main_email">
								</div>
								-->


								<div class="field__group">
									<label class="field__group__label">{{ $t('TIN') }}</label>
									<input class="field__group__input"
										   type="text"
										   spellcheck="false"
										   v-model="contact.tin"
										   @input="set_contact_tin">
								</div>
							</div>
							<div class="field-container">
								<div class="field__group">
									<label class="field__group__label">{{ $t('Complete_fiscal_address') }}</label>
									<input class="field__group__input"
										   type="text"
										   spellcheck="false"
										   v-model="contact.complete_fiscal_address"
										   @input="set_contact_complete_fiscal_address">
								</div>

							</div>

							<!--
							<div v-if="contact.person_type.id === 1">
								<div class="field-container">

									<div class="field__group">
										<label class="field__group__label">{{ $t('Organization_s_Company')
											}}</label>
										<input class="field__group__input"
											   type="text"
											   spellcheck="false"
											   v-model="contact.organization"
											   @input="set_contact_organization">
									</div>

								</div>
							</div>
							-->
							<!--
							<div class="form-section" v-if="contact.person_type.id === 2">
								<div class="field-container">

									<div class="field__group">
										<label class="field__group__label">{{ $t('Representative') }}</label>
										<input class="field__group__input"
											   type="text"
											   spellcheck="false"
											   v-model="contact.representative"
											   @input="set_contact_representative">
									</div>

									<div class="field__group">
										<label class="field__group__label">{{ $t('Representative_TIN') }}</label>
										<input class="field__group__input"
											   type="text"
											   spellcheck="false"
											   v-model="contact.representative_tin"
											   @input="set_contact_representative_tin">
									</div>


								</div>
							</div>
							-->

						</div>
					</div>
					<table class="dialog_buttons_table">
						<tr>
							<td>
								<div>
									<div @click.prevent="onCancelCreateNewContact"
										 style="width: fit-content; margin-right: auto">
										<icon-button icon="times" :text="''"
													 icon_color="black"
													 text_color="black" border_color="lightgray" min_width="80px"
													 max_width="80px"></icon-button>
									</div>
								</div>
							</td>
							<td>
								<div>
									<div @click.prevent="onCreateNewContact"
										 style="width: fit-content; margin-left: auto">
										<icon-button icon="check" :text="''"
													 icon_color="black"
													 text_color="black" border_color="lightgray" min_width="80px"
													 max_width="80px"></icon-button>
									</div>
								</div>
							</td>
						</tr>
					</table>

				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :fileId="appraisalfile.id"
							  :fileNumber="appraisalfile.number" :invoiceOpen="invoiceOpen"
							  :invoiceNumber="appraisalinvoice.full_number"
							  :realEstates="appraisalinvoice_lines" :invoiceId="appraisalinvoice.id"></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('Appraisal_invoice') }} <span
							v-if="appraisalinvoice.full_number">{{ appraisalinvoice.full_number
						}}</span>
						<span v-if="appraisalinvoice.dirty">*</span>
					</h1>
					<message
							v-if="appraisalinvoice.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(appraisalinvoice.date_created)
							}}</p>
						<p class="small">{{ $t('Last_modified')
							}}: {{ millis_to_time(appraisalinvoice.date_modified) }}</p>
					</div>

					<vue-tabs>
						<v-tab :title="invoicecontent_text">
							<div class="tab_content">
								<form class="bt-form">
									<div class="section-container">
										<h3>{{ $t('Client') }}</h3>
										<div class="field-container" style="background-color: #fafafc; padding: 2rem;">


											<div class="ms-container">
												<label class="field__group__label">{{ $t('Surnames_name_or_company')
													}}<span
															v-if="tags_display">&emsp;<span
															class="pdf_tag">PDF</span></span></label>
												<multiselect placeholder=""
															 :value="petitionerValue"
															 :options="object_to_array(contacts)"
															 track-by="id"
															 :label="'complete_name'"
															 :searchable="true"
															 v-model="appraisalinvoice.petitioner"
															 @input="set_appraisalinvoice_petitioner">
													<span slot="noResult" slot-scope="props"
														  @click.prevent="onAddNewContact"
														  v-bind:style="{color: no_result_color}"
														  @mouseover="no_result_color = 'rgb(0, 135, 248)'"
														  @mouseleave="no_result_color = 'black'">Cap resultat. Click per crear nou.</span>
												</multiselect>
											</div>
											<div v-if="appraisalinvoice.petitioner">
												<div @click.prevent="onAddNewPetitioner"
													 style="width: fit-content; margin-left: auto">
													<icon-button icon="plus-circle"
																 :text="add_petitioner_button_text"
																 icon_color="black"
																 text_color="black"
																 border_color="lightgray"></icon-button>
												</div>
											</div>

											<div v-if="object_length(appraisalinvoice_petitioners) > 0">
												<div class="text_table">
													<!--
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell" layout="row">
														<input type="text" :placeholder="filter_placeholder" self="size-x1"
															   v-model="petitioner_table.filter"
															   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
															   data-step="9" data-position="top">
													</div>
												</div>
												-->
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="data-table-appraisalinvoice_petitioners"
																	   :source="object_to_array(appraisalinvoice_petitioners)"
																	   :filterable="false"
																	   :striped="petitioner_table.striped"
																	   :editable="petitioner_table.editable"
																	   :line-numbers="petitioner_table.lineNumbers">
																<datatable-column id="actions-petitioners"
																				  :label="actions_text"
																				  width="160px"
																				  :sortable="false"
																				  :groupable="false"></datatable-column>
																<datatable-column
																		v-for="column in petitioner_table.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<template slot="actions-petitioners" scope="cell">
																	<table class="actions-table">
																		<tr>
																			<td class="actions_td"><a
																					@click="editContact(cell.row)"
																					style="cursor: pointer;"
																					:title="edit_text">
																				<icon name="pencil" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																			<td class="actions_td"><a
																					@click="discardPetitioner(cell.row)"
																					style="cursor: pointer;"
																					:title="delete_text">
																				<icon name="times" scale=".9"
																					  color="gray"></icon>
																			</a></td>
																		</tr>
																	</table>
																</template>


															</datatable>
														</div>
													</div>
												</div>
											</div>
											<div v-else=""><br>{{ $t('No_petitioners_text') }}</div>

										</div>
									</div>

									<div class="section-container">
										<h3>{{ $t('Date') }} {{ $t('and') }} {{ $t('invoice_fiscal_number') }}</h3>
										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Date_of_invoice') }}<span
														v-if="tags_display">&emsp;<span
														class="pdf_tag">PDF</span></span></label>
												<input class="field__group__input"
													   type="date"
													   spellcheck="false"
													   v-model="appraisalinvoice.invoicedate"
													   @input="set_appraisalinvoice_invoicedate">
											</div>
											<div class="field__group">
												<label class="field__group__label">{{ $t('Invoice_fiscal_number') }}<span
														v-if="tags_display">&emsp;<span
														class="pdf_tag">PDF</span></span></label>
												<input class="field__group__input"
													   type="number"
													   spellcheck="false"
													   v-model="appraisalinvoice.fiscal_number"
													   @input="set_appraisalinvoice_fiscal_number">
											</div>
										</div>
									</div>


									<!--
									<div class="section-container">
										<h3>{{ $t('Client') }}</h3>
										<div class="field-container">
											<div class="ms-container">
												<label class="field__group__label">{{ $t('Client') }}<span
														v-if="tags_display">&emsp;<span
														class="bde_tag">BdE</span>&emsp;<span
														class="pdf_tag">PDF</span></span></label>
												<multiselect placeholder=""
															 :value="petitionerValue"
															 :options="object_to_array(contacts)"
															 track-by="id"
															 :label="'complete_name'"
															 :searchable="true"
															 v-model="appraisalinvoice.petitioner"
															 @input="set_appraisalinvoice_petitioner"></multiselect>
											</div>
										</div>
										<div class="field-container">
											<div class="field__group" v-if="appraisalinvoice.petitioner">
												<label class="field__group__label">{{ $t('TIN') }}<span
														v-if="tags_display">&emsp;<span
														class="bde_tag">BdE</span>&emsp;<span
														class="pdf_tag">PDF</span></span></label>

												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="appraisalinvoice.petitioner.tin"
													   @input="set_appraisalinvoice_petitioner_tin">
											</div>
										</div>
									</div>
									-->
									<div class="section-container">
										<h3>{{ $t('Quote_reference') }}</h3>
										<div class="field-container" style="background-color: #fafafc; padding: 2rem;">
											<div class="ms-container">
												<label class="field__group__label">{{ $t('Quote') }}</label>
												<multiselect placeholder=""
															 :value="quoteValue"
															 :options="object_to_array(appraisalinvoice_appraisalquotes)"
															 track-by="id"
															 :label="'full_number'"
															 :searchable="true"
															 v-model="appraisalinvoice.quote"
															 @input="set_appraisalinvoice_quote"></multiselect>
											</div>
											<div>
												<div @click.prevent="onImportQuoteConcepts"
													 style="width: fit-content; margin-left: auto">
													<icon-button icon="plus-circle"
																 :text="import_quote_concepts_button_text"
																 icon_color="black"
																 text_color="black"
																 border_color="lightgray"></icon-button>
												</div>
											</div>
										</div>

									</div>
									<div class="section-container">
										<h3>{{ $t('Invoice_lines') }}</h3>
										<div>
											<div @click.prevent="onCreateNewLine"
												 style="width: fit-content; margin-left: auto">
												<icon-button icon="plus-circle" :text="add_line_button_text"
															 icon_color="black"
															 text_color="black" border_color="lightgray"></icon-button>
											</div>
										</div>
										<div v-if="object_length(appraisalinvoice_lines) > 0">
											<div class="text_table">
												<!--
											<div class="grid-row" layout="row top-stretch">
												<div class="grid-cell" layout="row">
													<input type="text" :placeholder="filter_placeholder" self="size-x1"
														   v-model="line_table.filter"
														   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
														   data-step="9" data-position="top">
												</div>
											</div>
											-->
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<datatable id="data-table-main"
																   :source="object_to_array(appraisalinvoice_lines)"
																   :filterable="false"
																   :striped="line_table.striped"
																   :editable="line_table.editable"
																   :line-numbers="line_table.lineNumbers">

															<datatable-column
																	v-for="column in line_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:aggregators="column.aggregators"
																	:formatter="column.formatter">
															</datatable-column>
															<template slot="description" scope="cell">
																<div class="">
																	<textarea class="field__group__textarea"
																			  rows="2"
																			  spellcheck="false"
																			  v-model="cell.row['description']"
																			  @input="set_line_description($event, cell.row)"></textarea>
																</div>
															</template>
															<template slot="units" scope="cell">
																<div class="">
																	<input type="number"
																		   min="0"
																		   step="0.1"
																		   v-model="cell.row['units']"
																		   @input="set_line_units($event, cell.row)">

																</div>
															</template>
															<template slot="unit_price" scope="cell">
																<div class="">
																	<input type="number"
																		   min="0"
																		   v-model="cell.row['unit_price']"
																		   @input="set_line_unit_price($event, cell.row)">

																</div>
															</template>
															<datatable-column id="actions-lines"
																			  :label="actions_text"
																			  width="70px"
																			  :sortable="false"
																			  :groupable="false"></datatable-column>


															<template slot="actions-lines" scope="cell">
																<table class="actions-table">
																	<tr>
																		<!--
																		<td class="actions_td"><a
																				@click="editLine(cell.row)"
																				style="cursor: pointer;"
																				:title="edit_text">
																			<icon name="pencil" scale=".9"
																				  color="gray"></icon>
																		</a></td>
																		-->
																		<td class="actions_td"><a
																				@click="deleteLine(cell.row)"
																				style="cursor: pointer;"
																				:title="delete_text">
																			<icon name="trash-o" scale=".9"
																				  color="gray"></icon>
																		</a></td>
																	</tr>
																</table>
															</template>
															<template slot="property_type" scope="cell">
																	<span v-if="cell.row['property_type']"><span
																			v-if="currentLocale === 'ca'">{{ cell.row['property_type']['name_ca']
																		}}</span><span
																			v-else-if="currentLocale === 'en'">{{ cell.row['property_type']['name_en']
																		}}</span><span
																			v-else>{{ cell.row['property_type']['name_es']
																		}}</span></span>
															</template>
															<template slot="appraisal_id" scope="cell">
																<div>

																	<multiselect placeholder=""
																				 :value="line_appraisaldateValue"
																				 :options="object_to_array(appraisalinvoice_lines[cell.row['id']]['appraisals'])"
																				 track-by="id"
																				 :label="'id'"
																				 :searchable="false"
																				 v-model="cell.row['appraisal_id']"
																				 @input="set_appraisalinvoice_line_appraisal_id($event, cell.row['id'])"
																				 selectedLabel=""
																				 selectLabel=""
																				 deselectLabel=""></multiselect>

																</div>
															</template>
															<template slot="appraisaldate" scope="cell">
																<div>
																	<span v-if="cell.row.appraisal_id">{{ cell.row.appraisal_id.appraisaldate
																		}}</span>
																</div>
															</template>
															<template slot="line_total_adopted_value"
																	  scope="cell">
																<div>
																	<span v-if="cell.row.appraisal_id">{{ cell.row.appraisal_id.line_total_adopted_value | formatNumber
																		}} €</span>
																</div>
															</template>
														</datatable>
													</div>
												</div>
											</div>
										</div>

									</div>
									<div class="section-container">
										<h3>{{ $t('Final_price') }}</h3>
										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Discount_pct') }}<span
														v-if="tags_display">&emsp;<span
														class="pdf_tag">PDF</span></span></label>
												<input class="field__group__input"
													   type="number"
													   max="100"
													   min="0"
													   step="1"
													   spellcheck="false"
													   v-model="appraisalinvoice.discount_pct"
													   @input="set_appraisalinvoice_discount_pct">
											</div>
											<div class="field__group">
												<label class="field__group__label">{{ $t('Final_price') }}<span
														v-if="tags_display">&emsp;<span
														class="pdf_tag">PDF</span></span></label>
												<!--<input class="field__group__input"
													   type="number"
													   spellcheck="false"
													   v-model="appraisalinvoice.final_price"
													   @input="set_appraisalinvoice_final_price">-->
												<span><strong>{{ appraisalinvoice.final_price | formatNumber
													}} €</strong></span>
											</div>
										</div>
										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Discount_notes') }}<span
														v-if="tags_display">&emsp;<span
														class="pdf_tag">PDF</span></span></label>
												<textarea class="field__group__textarea"
														  rows="3"
														  spellcheck="false"
														  v-model="appraisalinvoice.discount_notes"
														  @input="set_appraisalinvoice_discount_notes"></textarea>
											</div>
										</div>
									</div>
									<div class="section-container">
										<h3>{{ $t('Fiscal_parameters') }}</h3>
										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('VAT_pct') }}<span
														v-if="tags_display">&emsp;<span
														class="pdf_tag">PDF</span></span></label>
												<input class="field__group__input"
													   type="number"
													   spellcheck="false"
													   v-model="appraisalinvoice.vat_pct"
													   @input="set_appraisalinvoice_vat_pct">
											</div>
										</div>
									</div>
									<div class="section-container">
										<h3>{{ $t('Payment_conditions') }}</h3>
										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Bank_name') }}<span
														v-if="tags_display">&emsp;<span
														class="pdf_tag">PDF</span></span></label>
												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="appraisalinvoice.bank_name"
													   @input="set_appraisalinvoice_bank_name">
											</div>
											<div class="field__group">
												<label class="field__group__label">IBAN<span
														v-if="tags_display">&emsp;<span
														class="pdf_tag">PDF</span></span></label>
												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="appraisalinvoice.iban"
													   @input="set_appraisalinvoice_iban">
											</div>
										</div>
									</div>
									<div class="section-container">
										<h3>{{ $t('Signature') }}</h3>
										<div class="field-container">
											<div class="field__group" v-if="appraisalinvoice.signature_uid === user.id || !appraisalinvoice.is_signed ">
												<label class="field__group__label">{{ $t('Sign_invoice') }}</label>
												<input class="field__group__input"
													   type="checkbox"
													   spellcheck="false"
													   v-model="appraisalinvoice.is_signed"
													   @click="set_appraisalinvoice_is_signed">
											</div>
											<div class="field__group" v-else="">
												<span></span>

											</div>
											<div class="field-group">
												<div v-if="appraisalinvoice.is_signed">
													<img :src="appraisalinvoice.signature_base64" alt="s" style="width:200px;">
													<br>
													<span><strong>{{ appraisalinvoice.signature_name }}</strong></span>
													<br>
													<span>{{ $t('Signed') }} {{ appraisalinvoice.signature_date | formatDateAsLocal }}</span>
												</div>
											</div>

										</div>
										<hr>


									</div>


								</form>
								<div v-if="object_length(appraisalinvoice_petitioners) > 0 && object_length(appraisalinvoice_lines) > 0">
									<div @click.prevent="onCreatePdf" style="width: fit-content; margin-left: auto">
										<icon-button icon="file-pdf-o" :text="pdf_button_text"
													 icon_color="black"
													 text_color="black" border_color="lightgray"></icon-button>
									</div>
								</div>
								<div v-else="">
									<div v-if="!this.appraisalinvoice_petitioners">
										<message
												:text="petitioners_missing_error_text" icon_name="exclamation"
												icon_color="darkred"
												border_color="red" text_color="darkred">
										</message>
									</div>
									<div v-if="!this.appraisalinvoice_lines">
										<message
												:text="lines_missing_error_text" icon_name="exclamation"
												icon_color="darkred"
												border_color="red" text_color="darkred">
										</message>
									</div>


								</div>
							</div>
						</v-tab>
						<v-tab :title="metadata_text">
							<div class="tab_content">
								<form class="bt-form">
									<div class="section-container">
										<h3>{{ $t('Description') }}</h3>

										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Appraisal_invoice_description')
													}}</label>
												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="appraisalinvoice.description"
													   @input="set_appraisalinvoice_description">
											</div>
										</div>

									</div>
									<div class="section-container">
										<h3>{{ $t('Invoice_number') }}</h3>

										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Invoice_number') }}</label>
												<input class="field__group__input"
													   type="number"
													   maxlength="2"
													   spellcheck="false"
													   v-model="appraisalinvoice.number"
													   @input="set_appraisalinvoice_number">
											</div>
											<div class="field__group">
												<label class="field__group__label">{{ $t('Version') }}</label>
												<input class="field__group__input"
													   type="number"
													   maxlength="2"
													   spellcheck="false"
													   v-model="appraisalinvoice.version"
													   @input="set_appraisalinvoice_version">
											</div>
										</div>
									</div>
									<div class="section-container">
										<h3>{{ $t('Status') }}</h3>
										<div class="field-container">
											<div class="ms-container">
												<label class="field__group__label">{{ $t('Status') }}</label>
												<multiselect placeholder=""
															 :value="statusValue"
															 :options="status_invoicesOptions"
															 track-by="id"
															 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
															 :searchable="true"
															 v-model="appraisalinvoice.status"
															 @input="set_appraisalinvoice_status"></multiselect>
											</div>

										</div>
									</div>


								</form>
							</div>
						</v-tab>
					</vue-tabs>

					<div>
						<div @click.prevent="onGoUp" style="width: fit-content; margin-left: auto">
							<icon-button icon="chevron-left" :text="goup_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentAppraisalInvoice({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentAppraisalInvoice({go_up: true})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<message
							v-if="appraisalinvoice.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<!--
					<bar>
					</bar>
					-->

				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import { dateMixin, localStorageMixin, mathMixin, objectsMixin, dataURLMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import petitioner_typeOptions from '../../../options/petitioner_types'
    import status_invoicesOptions from '../../../options/status_invoices'
    import honorificTitleOptions from '../../../options/honorific_titles'
    import personTypeOptions from '../../../options/person_types'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    const numeral = require('numeral')

    const {map} = require('p-iteration')
    const {forEach} = require('p-iteration')

    let pdfMake = require('pdfmake/build/pdfmake.js')
    let pdfFonts = require('pdfmake/build/vfs_fonts.js')
    pdfMake.vfs = pdfFonts.pdfMake.vfs

    pdfMake.tableLayouts = {
        hLineWidth: {
            hLineWidth: function (i, node) {
                return 0.5;
            }
        }
    }

    export default {
        name: 'appraisalinvoice-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            mathMixin,
            objectsMixin,
            dataURLMixin
        ],

        data: () => ({
            value: null,
            cover_photo_dataURL: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
            no_result_color: 'black',
            loading: true,
            master_loading: true,
            selecting_line: false,
            creating_contact: false,
            filesOpen: true,
            fileOpen: true,
            invoiceOpen: true,
            error: null,
            quoteValue: null,
            success_message: null,
            editing_line: false,
            editing_line_text_color: 'black',
            editing_line_border_color: 'lightgray',
            metadata_text: Vue.i18n.translate('Version'),
            invoicecontent_text: Vue.i18n.translate('Invoice_content'),
            invoice_title_error_text: Vue.i18n.translate('Invoice_title_missing_error_text'),
            new_real_estate_button_text: Vue.i18n.translate('Create_new_real_estate'),
            petitioners_missing_error_text: Vue.i18n.translate('Petitioners_missing_error_text'),
            add_petitioner_button_text: Vue.i18n.translate('Add_client'),
            lines_missing_error_text: Vue.i18n.translate('Lines_missing_error_text'),
            import_quote_concepts_button_text: Vue.i18n.translate('Import_quote_concepts'),
            select_real_estate_button_text: Vue.i18n.translate('Add_real_estate'),
            add_line_button_text: Vue.i18n.translate('Add_invoice_line'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            pdf_button_text: Vue.i18n.translate('Print_invoice_in_PDF'),
            save_button_text: Vue.i18n.translate('Save'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            line_appraisaldateValue: null,
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            discard_text: Vue.i18n.translate('Discard'),
            openlink_text: Vue.i18n.translate('Open_link_in_new_tab'),
            petitionerValue: null,
            entityValue: null,
            appraiserValue: null,
            supervisorValue: null,
            importLineValue: null,
            petitioner_typeValue: null,
            statusValue: null,
            petitioner_typeOptions,
            status_invoicesOptions,
            honorificTitleOptions,
            personTypeOptions,
            line_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: 120,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'unit_price',
                        label: Vue.i18n.translate('Unit_price'),
                        width: 40,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'units',
                        label: Vue.i18n.translate('Units'),
                        width: 40,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'price',
                        label: Vue.i18n.translate('Price'),
                        width: 20,
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.total
                        ]
                    }
                ],
                selected: []
            },
            petitioner_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'complete_name',
                        label: Vue.i18n.translate('Client'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'tin',
                        label: Vue.i18n.translate('TIN'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'complete_fiscal_address',
                        label: Vue.i18n.translate('Fiscal_address'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'main_email',
                        label: 'E-mail',
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }

                ],
                selected: []
            },
        }),

        created () {
            this.FETCH_APPRAISALINVOICE_LINES({
                path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'lines',
                appraisalinvoice_id: this.$route.query.id
            })
                .then(() => {
                    this.FETCH_CONTACTS({path: 'contacts' + '/' + this.$route.query.id + '/'})
                        .then(() => {

                            this.FETCH_APPRAISALINVOICE_APPRAISALQUOTES({path: 'appraisalfiles' + '/' + this.$route.query.file_id + '/' + 'appraisalquotes' + '/'})
                                .then(() => {

                                    this.FETCH_APPRAISALINVOICE_PETITIONERS({
                                        path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'petitioners',
                                        appraisalinvoice_id: this.$route.query.id
                                    })
                                        .then(() => {

                                        if(_.size(this.appraisalinvoice_lines)>0){
                                            this.calc_final_price()
										}

                                            this.master_loading = false
                                        })
                                })
                        })
                })
        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            SideNavBar,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator
        },

        computed: {
            ...mapGetters([
                'theme',
                'tags_display',
                'contacts',
                'currentLocale',
                'appraisal',
                'entities',
                'supervisors',
                'appraisers',
                'appraisalfile',
                'appraisalinvoice',
                'appraisalinvoice_lines',
                'appraisalinvoice_appraisalquotes',
                'appraisalinvoice_petitioners',
                'appraisalquotes',
                'line',
                'lines',
                'contact',
				'user'
            ])
        },

        methods: {
            ...mapActions(
                [
                    'CHECK_APPRAISALINVOICE_LINE_APPRAISALS',
                    'CREATE_NEW_LINE',
                    'CREATE_NEW_CONTACT',
                    'UPDATE_CONTACT',
                    'DELETE_LINE',
                    'DELETE',
                    'FETCH_APPRAISALINVOICE_LINES',
                    'FETCH_APPRAISALINVOICE_APPRAISALQUOTES',
                    'FETCH_APPRAISALINVOICE_PETITIONERS',
                    'FETCH_CONTACTS',
                    'FETCH_ENTITIES',
                    'FETCH_LINE',
                    'FETCH_LINES',
                    'FETCH_APPRAISALQUOTES',
                    'FETCH',
                    'GET',
                    'RESET_MARKETSTUDY',
                    'RESET_LINE',
                    'SET_LINE',
                    'SET_VALUE',
                    'UPDATE_LINE',
                    'RESET_CONTACT',
                    'SET_CONTACT',
                    'SET_CONTACT_MAIN_EMAIL',
                    'SET_CONTACT_NAME',
                    'SET_CONTACT_ORGANIZATION',
                    'SET_CONTACT_PERSON_TYPE',
                    'SET_CONTACT_REPRESENTATIVE',
                    'SET_CONTACT_REPRESENTATIVE_TIN',
                    'SET_CONTACT_SURNAMES',
                    'SET_CONTACT_TIN',
                    'SET_CONTACT_TITLE',
                    'SET_CONTACT_COMPLETE_NAME',
                    'SET_CONTACT_COMPLETE_FISCAL_ADDRESS',
                    'SET_APPRAISALINVOICE_LINE_APPRAISAL_ID',
                    'SET_APPRAISALINVOICE_INVOICEDATE',
                    'SET_APPRAISALINVOICE_SEND_TO_BDE',
                    'SET_APPRAISALINVOICE_DESCRIPTION',
                    'SET_APPRAISALINVOICE_TITLE',
                    'SET_APPRAISALINVOICE_NUMBER',
                    'SET_APPRAISALINVOICE_VERSION',
                    'SET_APPRAISALINVOICE_ENTITY',
                    'SET_APPRAISALINVOICE_SUPERVISOR',
                    'SET_APPRAISALINVOICE_APPRAISER',
                    'SET_APPRAISALINVOICE_PETITIONER',
                    'SET_APPRAISALINVOICE_PETITIONER_TYPE',
                    'SET_APPRAISALINVOICE_VAT_PCT',
                    'SET_APPRAISALINVOICE_STATUS',
                    'SET_APPRAISALINVOICE_QUOTE',
                    'SET_APPRAISALINVOICE_FULL_NUMBER',
                    'SET_LINE_DESCRIPTION',
                    'SET_LINE_UNITS',
                    'SET_LINE_UNIT_PRICE',
                    'SET_LINE_PRICE',
                    'UPDATE_APPRAISALINVOICE',
                    'UPDATE_APPRAISALINVOICE_LINES',
                    'SET_APPRAISALINVOICE_BASE_PRICE',
                    'SET_APPRAISALINVOICE_DISCOUNT_PCT',
                    'SET_APPRAISALINVOICE_FINAL_PRICE',
                    'SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT',
                    'SET_APPRAISALINVOICE_DISCOUNT_NOTES',
                    'SET_APPRAISALINVOICE_BANK_NAME',
                    'SET_APPRAISALINVOICE_IBAN',
                    'SET_APPRAISALINVOICE_FISCAL_NUMBER',
                    'SET_APPRAISALINVOICE_SIGNATURE_NAME',
                    'SET_APPRAISALINVOICE_SIGNATURE_BASE64',
                    'SET_APPRAISALINVOICE_SIGNATURE_DATE',
                    'SET_APPRAISALINVOICE_SIGNATURE_EMAIL',
                    'SET_APPRAISALINVOICE_SIGNATURE_UID',
                    'SET_APPRAISALINVOICE_IS_SIGNED',


                ]),

            set_appraisalinvoice_description: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_DESCRIPTION(e.target.value)
            }, 1000),
            set_appraisalinvoice_invoicedate: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_INVOICEDATE(e.target.value)
            }, 1000),
            set_appraisalinvoice_number: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_NUMBER(Number(e.target.value))

                let filenumber = ''
                filenumber = this.appraisalfile.number

                let s = Number(e.target.value) + ''
                while (s.length < 2) s = '0' + s
                let invoicenumber = s

                let p = this.appraisalinvoice.version + ''
                while (p.length < 2) p = '0' + p
                let invoiceversion = p

                let fullnumber = filenumber + '/' + invoicenumber + '/' + invoiceversion

                this.SET_APPRAISALINVOICE_FULL_NUMBER(fullnumber)
            }, 1000),
            set_appraisalinvoice_send_to_bde: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_SEND_TO_BDE(e.target.value)
            }, 1000),
            set_appraisalinvoice_title: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_TITLE(e.target.value)
            }, 1000),
            set_appraisalinvoice_version: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_VERSION(Number(e.target.value))

                let filenumber = ''
                filenumber = this.appraisalfile.number

                let s = this.appraisalinvoice.number + ''
                while (s.length < 2) s = '0' + s
                let invoicenumber = s

                let p = Number(e.target.value) + ''
                while (p.length < 2) p = '0' + p
                let invoiceversion = p

                let fullnumber = filenumber + '/' + invoicenumber + '/' + invoiceversion

                this.SET_APPRAISALINVOICE_FULL_NUMBER(fullnumber)

            }, 1000),
            set_appraisalinvoice_petitioner: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_PETITIONER(e)
            }, 1000),
            set_appraisalinvoice_petitioner_type: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_PETITIONER_TYPE(e)
            }, 1000),
            set_appraisalinvoice_entity: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_ENTITY(e)
            }, 1000),
            set_appraisalinvoice_supervisor: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_SUPERVISOR(e)
            }, 1000),
            set_appraisalinvoice_appraiser: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_APPRAISER(e)
            }, 1000),
            set_appraisalinvoice_vat_pct: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_VAT_PCT(Number(e.target.value))
            }, 1000),
            set_appraisalinvoice_status: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_STATUS(e)
            }, 1000),
            set_appraisalinvoice_quote: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_QUOTE(e)
            }, 500),
            set_appraisalinvoice_base_price: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_BASE_PRICE(Number(e.target.value))
            }, 500),
            set_appraisalinvoice_discount_pct: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_DISCOUNT_PCT(Number(e.target.value))
                this.calc_final_price()
            }, 500),
            set_appraisalinvoice_final_price: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_FINAL_PRICE(Number(e.target.value))
            }, 500),
            set_appraisalinvoice_final_price_incl_vat: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT(Number(e.target.value))
            }, 500),
            set_appraisalinvoice_discount_notes: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_DISCOUNT_NOTES(e.target.value)
            }, 500),
            set_appraisalinvoice_fiscal_number: _.debounce(function(e){
                this.SET_APPRAISALINVOICE_FISCAL_NUMBER(Number(e.target.value))
            }, 500),
            set_contact_name: _.debounce(function (e) {
                let name = e.target.value
                let surnames = ''
                if (this.contact.surnames) {
                    surnames = this.contact.surnames
                }

                let complete_name = surnames + ', ' + name
                if (!surnames) {
                    complete_name = name
                }
                this.SET_CONTACT_NAME(name)
                this.SET_CONTACT_COMPLETE_NAME(complete_name)

            }, 500),
            set_contact_main_email: _.debounce(function (e) {
                this.SET_CONTACT_MAIN_EMAIL(e.target.value)
            }, 500),
            set_contact_organization: _.debounce(function (e) {
                this.SET_CONTACT_ORGANIZATION(e.target.value)
            }, 500),
            set_contact_person_type: _.debounce(function (e) {
                this.SET_CONTACT_PERSON_TYPE(e)
            }, 500),
            set_contact_representative: _.debounce(function (e) {
                this.SET_CONTACT_REPRESENTATIVE(e.target.value)
            }, 500),
            set_contact_representative_tin: _.debounce(function (e) {
                this.SET_CONTACT_REPRESENTATIVE_TIN(e.target.value)
            }, 500),
            set_contact_surnames: _.debounce(function (e) {
                let surnames = e.target.value
                let name = ''
                if (this.contact.name) {
                    name = this.contact.name
                }
                let complete_name = surnames + ', ' + name
                if (!surnames) {
                    complete_name = name
                }
                this.SET_CONTACT_SURNAMES(surnames)
                this.SET_CONTACT_COMPLETE_NAME(complete_name)
            }, 500),
            set_contact_tin: _.debounce(function (e) {
                this.SET_CONTACT_TIN(e.target.value)
            }, 500),
            set_contact_title: _.debounce(function (e) {
                this.SET_CONTACT_TITLE(e)
            }, 500),
            set_contact_complete_fiscal_address: _.debounce(function(e){
                this.SET_CONTACT_COMPLETE_FISCAL_ADDRESS(e.target.value)
            }, 500),
            /*
			set_line_description: _.debounce(function(e){
				this.SET_LINE_DESCRIPTION(Number(e.target.value))
			}, 500),
			*/
            set_line_description: _.debounce(function (e, f) {

                // console.log('e: ')
                // console.log(e)
                // console.log('f: ')
                // console.log(f)

                // this.master_loading = true
                this.editing_line = true
                this.editing_line_text_color = 'whitesmoke'
                this.editing_line_border_color = 'whitesmoke'
                let description = e.target.value
                let obj = this.appraisalinvoice_lines
                let id = f['id']
                obj[id]['description'] = description

                this.UPDATE_APPRAISALINVOICE_LINES({
                    appraisalinvoice_id: this.appraisalinvoice.id,
                    object: obj
                }).then((res) => {
                    this.master_loading = false
                    this.editing_line = false
                    this.editing_line_text_color = 'black'
                    this.editing_line_border_color = 'lightgray'
                })
            }, 0),
            set_line_unit_price: _.debounce(function (e, f) {
                // this.master_loading = true
                this.editing_line = true
                this.editing_line_text_color = 'whitesmoke'
                this.editing_line_border_color = 'whitesmoke'
                let value = e.target.value
                if (!value) {
                    value = 0
                }
                let unit_price = Number(value)
                let obj = this.appraisalinvoice_lines
                let id = f['id']
                let units = obj[id]['units']
                if (!units) {
                    units = 0
                }
                obj[id]['unit_price'] = unit_price
                obj[id]['price'] = this.roundToTwo(units * unit_price)

                this.UPDATE_APPRAISALINVOICE_LINES({
                    appraisalinvoice_id: this.appraisalinvoice.id,
                    object: obj
                }).then((res) => {
                    this.calc_total_base_price(this.object_to_array(obj))
                    this.master_loading = false
                    this.editing_line = false
                    this.editing_line_text_color = 'black'
                    this.editing_line_border_color = 'lightgray'
                })

            }, 0),
            calc_total_base_price: function (lines_array) {

                let partial = 0
                let total_checked = 0

                for (let i = 0; i < lines_array.length; i++) {

                    partial = lines_array[i].price
                    total_checked = total_checked + partial
                }
                console.log('invoice total base price: ')
                console.log(total_checked)
                this.SET_APPRAISALINVOICE_BASE_PRICE(total_checked)
                this.calc_final_price()

            },
            set_line_units: _.debounce(function (e, f) {
                // this.master_loading = true
                this.editing_line = true
                this.editing_line_text_color = 'whitesmoke'
                this.editing_line_border_color = 'whitesmoke'
                let value = e.target.value
                if (!value) {
                    value = 0
                }
                let units = Number(value)
                let obj = this.appraisalinvoice_lines
                let id = f['id']
                obj[id]['units'] = units

                let unit_price = obj[id]['unit_price']
                if (!unit_price) {
                    unit_price = 0
                }
                obj[id]['price'] = this.roundToTwo(units * unit_price)

                this.UPDATE_APPRAISALINVOICE_LINES({
                    appraisalinvoice_id: this.appraisalinvoice.id,
                    object: obj
                }).then((res) => {
                    this.calc_total_base_price(this.object_to_array(obj))
                    this.master_loading = false
                    this.editing_line = false
                    this.editing_line_text_color = 'black'
                    this.editing_line_border_color = 'lightgray'
                })

            }, 0),

            set_line_price: _.debounce(function (e) {
                this.SET_LINE_PRICE(Number(e.target.value))
            }, 500),
            set_appraisalinvoice_bank_name: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_BANK_NAME(e.target.value)
            }, 500),
            set_appraisalinvoice_iban: _.debounce(function (e) {
                this.SET_APPRAISALINVOICE_IBAN(e.target.value)
            }, 500),
            set_appraisalinvoice_signature_name: _.debounce(function(e){
                this.SET_APPRAISALINVOICE_SIGNATURE_NAME(e.target.value)
            }, 500),
            set_appraisalinvoice_signature_base64: _.debounce(function(e){
                this.SET_APPRAISALINVOICE_SIGNATURE_BASE64(e.target.value)
            }, 500),
            set_appraisalinvoice_signature_date: _.debounce(function(e){
                this.SET_APPRAISALINVOICE_SIGNATURE_DATE(e.target.value)
            }, 500),
            set_appraisalinvoice_is_signed: _.debounce(function(e){
                if(this.appraisalinvoice.is_signed){
                    let s = this.user.s? this.user.s: null
                    let email = this.user.email? this.user.email : ''
                    let name = this.user.name + ' ' + this.user.surnames
                    let id = this.user.id? this.user.id : null
                    //console.log(id)
                    if(!id){
                        alert('Manca uid. Contactar amb l\'administrador del l\'app.')
                    }
                    this.SET_APPRAISALINVOICE_SIGNATURE_BASE64(s)
                    this.SET_APPRAISALINVOICE_SIGNATURE_NAME(name)
                    this.SET_APPRAISALINVOICE_SIGNATURE_EMAIL(email)
                    this.SET_APPRAISALINVOICE_SIGNATURE_UID(id)
                    // unix seconds
                    this.SET_APPRAISALINVOICE_SIGNATURE_DATE(moment().format('X'))
                    this.onSaveCurrentAppraisalInvoice({go_up: false})
                }else{
                    this.SET_APPRAISALINVOICE_SIGNATURE_BASE64(null)
                    this.SET_APPRAISALINVOICE_SIGNATURE_NAME(null)
                    this.SET_APPRAISALINVOICE_SIGNATURE_EMAIL(null)
                    this.SET_APPRAISALINVOICE_SIGNATURE_UID(null)
                    this.SET_APPRAISALINVOICE_SIGNATURE_DATE(null)
                    this.onSaveCurrentAppraisalInvoice({go_up: false})
                }
                this.$forceUpdate()
            }, 0),
            set_appraisalinvoice_signature_email: _.debounce(function(e){
                this.SET_APPRAISALINVOICE_SIGNATURE_EMAIL(e.target.value)
            }, 500),
            set_appraisalinvoice_signature_uid: _.debounce(function(e){
                this.SET_APPRAISALINVOICE_SIGNATURE_UID(e.target.value)
            }, 500),
            set_import_line: function () {
                console.log('set_import_line')
                /*
				this.master_loading = true
				this.FETCH_TEMP_REALESTATE_MARKETSTUDIES({path: 'line_marketstudies' + '/' + this.marketstudy.importLine.id + '/'})
					.then(() => {
						this.master_loading = false
					})
					*/
            },
            onCancelImportNewLine: function () {
                this.selecting_line = false

            },
            onImportQuoteConcepts: function () {
                let quote_id = this.appraisalinvoice.quote.id
                console.log(quote_id)

                let obj = {}

                let intro_description_0 = ''
                let intro_description_1 = ''
                if (this.currentLocale === 'ca') {
                    intro_description_0 = 'Valoració de '
                    intro_description_1 = 'ubicat a'
                } else if (this.currentLocale === 'en') {
                    intro_description_0 = 'Valuation of '
                    intro_description_1 = 'situated in'
                } else {
                    intro_description_0 = 'Valoración de '
                    intro_description_1 = 'ubicado en'
                }

                this.FETCH({
                    path: 'appraisalquotes' + '/' + quote_id + '/',
                    appraisalquote_id: quote_id
                }).then((res) => {

                    console.log('&%&%&%&% FETCH res: ')
                    console.log(res)

                    let realestates = res['realestates']

                    let discount_pct = res['discount_pct']
                    if (!discount_pct) {
                        discount_pct = 0
                    }
                    let discount_notes = res['discount_notes']

					if(!discount_notes){
                        discount_notes = null
					}

                    if(!discount_pct){
                        discount_pct = 0
                    }

                    if(!realestates){
                        realestates = null
                    }

                    this.appraisalinvoice.discount_pct = discount_pct
                    this.appraisalinvoice.discount_notes = discount_notes

                    if (this.appraisalinvoice_lines) {
                        obj = this.appraisalinvoice_lines

                    }

                    let tempCurrentLocale = () => {
                        return this.currentLocale
                    }

                    _.forEach(realestates, function (value) {
                        console.log('hop: ')
                        console.log(value)

                        let property_usage = ''
                        if (tempCurrentLocale() === 'ca') {
                            property_usage = value['property_type']['usage_type_ca']
                        } else if (tempCurrentLocale() === 'en') {
                            property_usage = value['property_type']['usage_type_en']
                        } else {
                            property_usage = value['property_type']['usage_type_es']
                        }

                        if (tempCurrentLocale() === 'ca' && property_usage[0] === 'H' || property_usage[0] === 'A' || property_usage[0] === 'E' || property_usage[0] === 'I' || property_usage[0] === 'O' || property_usage[0] === 'U') {
                            intro_description_0 = 'Valoració d\''
                        }

                        let id = value['id']
                        obj[id] = {}
                        obj[id] = value
                        obj[id]['description'] = intro_description_0 + property_usage.toLowerCase() + ' ' + intro_description_1 + ' ' + value['full_address']
                        obj[id]['units'] = 1
                        obj[id]['unit_price'] = value['quote_price_incl_travel_expenses']
                        obj[id]['price'] = value['quote_price_incl_travel_expenses']

                    })

                    this.UPDATE_APPRAISALINVOICE_LINES({
                        appraisalinvoice_id: this.appraisalinvoice.id,
                        object: obj
                    }).then((res) => {
                        this.calc_total_base_price(this.object_to_array(obj))
                        this.FETCH_APPRAISALINVOICE_LINES({path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'lines' + '/'})
                            .then(() => {
                                this.calc_final_price()
                                this.master_loading = false
                            })
                    })

                })

            },
            calc_final_price: function () {
                let final_price = 0
                console.log('calculating final price (invoice) --->:')
                _.forEach(this.appraisalinvoice_lines, function (value) {
                    console.log(value)
                    final_price = final_price + value['price']

                })

                console.log('this.appraisalinvoice.discount_pct: ')
                console.log(this.appraisalinvoice.discount_pct)

                let discount_coef = 1 - (this.appraisalinvoice.discount_pct / 100)

                final_price = this.roundToTwo(final_price * discount_coef)
                console.log('final_price: ')
                console.log(final_price)
                this.SET_APPRAISALINVOICE_FINAL_PRICE(final_price)
            },
            onCreateNewLine: function () {
                this.selecting_line = false
                this.master_loading = true

                this.RESET_LINE().then((res) => {
                    this.CREATE_NEW_LINE({
                        invoice_id: this.appraisalinvoice.id,
                        file_id: this.appraisalfile.id,
                        file_number: this.appraisalfile.number,
                        invoice_number: this.appraisalinvoice.number,
                        invoice_version: this.appraisalinvoice.version,
                        path: 'lines' + '/',
                        parent_path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'lines' + '/'
                    }).then((res) => {
                        this.FETCH_APPRAISALINVOICE_LINES({path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'lines' + '/'})
                            .then(() => {
                                this.calc_final_price()
                                this.master_loading = false
                            })
                    })
                })
            },
            checkCreateNewLine: function () {
                if (this.appraisalinvoice.dirty) {
                    const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
                    if (result) {
                        this.onCreateNewLine()
                    }
                } else {
                    this.onCreateNewLine()
                }
            },
            set_appraisalinvoice_line_appraisal_id: _.debounce(function (e, line_id) {
                this.SET_APPRAISALINVOICE_LINE_APPRAISAL_ID({
                    path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'lines' + '/' + line_id + '/' + 'appraisal_id',
                    value: e
                }).then((res) => {
                    this.$forceUpdate()
                })
            }, 1000),
            set_appraisalinvoice_petitioner_tin: _.debounce(function (e) {

                let tin = ''
                if (e.target.value) {
                    tin = e.target.value
                }
                console.log('the tin: ')
                console.log(tin)
                this.SET_VALUE({
                    path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'petitioner' + '/' + 'tin' + '/',
                    object: tin
                }).then((res) => {

                    this.SET_VALUE({
                        path: 'contacts' + '/' + this.appraisalinvoice.petitioner.id + '/' + 'tin' + '/',
                        object: tin
                    }).then((res) => {

                    })
                })
            }, 1000),
            onAddNewPetitioner: function () {
                this.master_loading = true

                let filenumber = ''
                filenumber = this.appraisalfile.number

                let s = this.appraisalinvoice.number + ''
                while (s.length < 2) s = '0' + s
                let invoicenumber = s

                let p = this.appraisalinvoice.version + ''
                while (p.length < 2) p = '0' + p
                let invoiceversion = p

                let obj = {}

                if (this.appraisalinvoice_petitioners) {
                    obj = this.appraisalinvoice_petitioners
                }

                let parent_obj = {}

                parent_obj['full_number'] = filenumber + '/' + invoicenumber + '/' + invoiceversion
                parent_obj['invoicedate'] = this.appraisalinvoice.invoicedate
                parent_obj['id'] = this.appraisalinvoice.id

                // console.log('heypppppppp')
                // console.log(obj)

                let contact_id = this.appraisalinvoice.petitioner.id
                obj[contact_id] = this.appraisalinvoice.petitioner

                this.SET_VALUE({
                    object: obj,
                    path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'petitioners',
                }).then((res) => {

                    this.SET_VALUE({
                        object: parent_obj,
                        path: 'contacts' + '/' + contact_id + '/' + 'appraisalinvoices' + '/' + this.$route.query.id,
                    }).then((res) => {

                        this.FETCH_APPRAISALINVOICE_PETITIONERS({
                            path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'petitioners',
                            appraisalinvoice_id: this.$route.query.id
                        }).then(() => {
                            this.master_loading = false
                        })
                    })
                })

            },
            onAddNewContact: function () {
                this.RESET_CONTACT().then((res) => {
                    this.creating_contact = true
                })
            },
            onCreateNewContact: function () {

                // vigilar, que no es guarda la id, date_created, path
                // al crear contacte d'empreses --> title amb gender neutral?

                let obj_copy = JSON.parse(JSON.stringify(this.contact))
                console.log('!!! --->')
                console.log(obj_copy)

                this.creating_contact = false
                this.master_loading = true

                this.CREATE_NEW_CONTACT({path: 'contacts', creating_from_main: false}).then((res) => {

                    obj_copy['id'] = this.contact.id
                    obj_copy['date_created'] = this.contact.date_created
                    obj_copy['path'] = this.contact.path

                    this.UPDATE_CONTACT({
                        object: obj_copy,
                        path: 'contacts' + '/' + res.key
                    }).then((res) => {
                        this.FETCH_CONTACTS({path: 'contacts' + '/'})
                            .then(() => {
                                this.SET_APPRAISALINVOICE_PETITIONER(this.contact)
                                this.master_loading = false
                            })
                    })

                })

            },
            onCancelCreateNewContact: function () {
                this.creating_contact = false

            },
            numFormat: function (value, symbol) {
                if (!value || value === 0 || value === '' || value === '-') {
                    return '-'
                } else {
                    return numeral(value).format('0,0.00') + ' ' + symbol
                }
            },
            intFormat: function (value, symbol) {
                if (!value || value === 0 || value === '' || value === '-') {
                    return '-'
                } else {
                    return numeral(value).format('0,0') + ' ' + symbol
                }
            },
            onCreatePdf: function (data) {
                this.master_loading = true

                // guardar automàticament
                this.onSaveCurrentAppraisalInvoice({go_up: false})

                // TODO: comprovar que totes les appraisals incloses en el appraisalinvoice tinguin la mateixa finalitat declarada, sinó fer apareixèr un warning message

                let lines = []
                let appraisals = []
                let marketstudies = []

                let tempNumFormat = (value, symbol) => {
                    return this.numFormat(value, symbol)
                }

                let tempIntFormat = (value, symbol) => {
                    return this.intFormat(value, symbol)
                }

                let tempCurrentLocale = () => {
                    return this.currentLocale
                }

                let fetchAppraisal = (data) => {
                    return new Promise((resolve, reject) => {
                        this.$store.dispatch('FETCH_APPRAISAL', data).then((res) => {
                            appraisals.push(res)
                            resolve(res)
                        })
                    })
                }

                let fetchLine = (data) => {
                    return new Promise((resolve, reject) => {
                        this.$store.dispatch('FETCH_REALESTATE', data).then((res) => {
                            console.log('fetching line...')
                            lines.push(res)
                            resolve(res)
                        })
                    })
                }

                let database_fetch = (data) => {
                    return new Promise((resolve, reject) => {
                        this.$store.dispatch('FETCH', data).then((res) => {
                            console.log('fetching...')
                            lines.push(res)
                            resolve(res)
                        })
                    })
                }

                let canvas_to_data_url = (data) => {
                    return new Promise((resolve, reject) => {

                        // fetch from the WHATWG fetch api:
                        const toDataURL = url => fetch(url)
                            .then(response => response.blob())
                            .then(blob => new Promise((resolve, reject) => {
                                const reader = new FileReader()
                                reader.onloadend = () => resolve(reader.result)
                                reader.onerror = reject
                                reader.readAsDataURL(blob)
                            }))

                        toDataURL(data.src)
                            .then(dataUrl => {
                                // console.log('RESULT:', dataUrl)
                                resolve({data_url: dataUrl, footer: data.footer, is_cover_photo: data.is_cover_photo})
                            })

                    })
                }

                let google_canvas_to_data_url = (data) => {
                    console.log('google_canvas_to_data_url data!: ')
                    console.log(data)
                    return new Promise((resolve, reject) => {

                        // fetch from the WHATWG fetch api:
                        const toDataURL = url => fetch(url)
                            .then(response => response.blob())
                            .then(blob => new Promise((resolve, reject) => {
                                const reader = new FileReader()
                                reader.onloadend = () => resolve(reader.result)
                                reader.onerror = reject
                                reader.readAsDataURL(blob)
                            }))

                        if (data.src) {
                            toDataURL(data.src)
                                .then(dataUrl => {
                                    // console.log('RESULT:', dataUrl)
                                    resolve({data_url: dataUrl, footer: data.footer})
                                })
                        } else {

                            resolve()

                        }
                    })
                }

                // address_table portada
                let address_table = []

                // taula identificació i localització
                let appraised_id_table = []

                // layour d'elements
                let elements_layout = {}

                let appraisal_review_table = []
                let line_review_table = []
                let comparable_review_table = []
                let marketstudy_review_table = []
                let appraisalfile_review_table = []
                let appraisalinvoice_review_table = []

                // variables

                let property_type = ''
                let address_street_name = ''
                let address_number = ''
                let address_floor = ''
                let address_door = ''
                let address_block = ''
                let address_staircase = ''
                let address_postal_code = ''
                let address_postal_code_only = ''
                let address_municipality = ''
                let address_province = ''
                let address_long = ''
                let address_short = ''
                let cad_ref = ''
                let reg_est_num = ''
                let purpose_notes = ''
                let appraisaldate = ''
                let invoicedate = ''
                let filenumber = ''
                let invoicenumber = ''
                let invoiceversion = ''
                let petitioner = ''
                let petitioner_type = ''
                let mandatary = ''
                let appraisal_purpose = ''
                let acc_mortgage_market_law = ''
                let acc_eco_decree = ''
                let appraiser = ''
                let appraiser_name = ''
                let appraiser_surnames = ''
                let appraiser_pa_number = ''
                let supervisor = ''
                let supervisor_name = ''
                let supervisor_surnames = ''
                let supervisor_pa_number = ''
                let technician_visiting = ''

                let full_number = this.appraisalinvoice.full_number

                let total_invoice_fees_without_vat = 0
                let invoice_vat = 0
                let total_invoice_fees_incl_vat = 0

                lines = this.appraisalinvoice_lines
                console.log('lines: ')
                console.log(lines)

                // console.log('map result: ')
                // console.log(result)

                // console.log('result.length: ')
                // console.log(result.length)

                let docDefinition = {
                    // settings
                    pageSize: 'A4',
                    pageOrientation: 'portrait',
                    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                    pageMargins: [40, 45, 20, 20],
                    // metadata
                    info: {
                        title: 'BARNA-TASA, S.A.',
                        author: 'BARNA-TASA, S.A.',
                        subject: 'BARNA-TASA, S.A.',
                        keywords: 'BARNA-TASA, S.A.',
                        creator: 'BARNA-TASA, S.A.',
                        producer: 'BARNA-TASA, S.A.'
                    },
                    styles: {
                        header_small: {
                            fontSize: 8,
                            bold: false
                        },
                        header_title: {
                            fontSize: 12,
                            bold: true
                        },
                        small: {
                            fontSize: 8,
                            bold: false
                        },
                        small_bold: {
                            fontSize: 8,
                            bold: true
                        },
                        small_bold_center: {
                            fontSize: 8,
                            bold: true,
                            alignment: 'center'
                        },
                        plain: {
                            fontSize: 9,
                            bold: false
                        },
                        plain_blue: {
                            fontSize: 9,
                            color: '#1a3856',
                            bold: false
                        },
                        plain_blue_bold: {
                            fontSize: 9,
                            color: '#1a3856',
                            bold: true
                        },
                        plain_green_bold: {
                            fontSize: 9,
                            color: '#009900',
                            bold: true
                        },
                        plain_bold: {
                            fontSize: 9,
                            bold: true
                        },
                        plain_bold_center: {
                            fontSize: 9,
                            bold: true,
                            alignment: 'center'
                        },
                        plain_bold_left: {
                            fontSize: 9,
                            bold: true,
                            alignment: 'left'
                        },
                        plain_bold_right: {
                            fontSize: 9,
                            bold: true,
                            alignment: 'right'
                        },
                        cover_brand: {
                            fontSize: 32,
                            color: '#1a3856',
                            bold: true
                        },
                        cover_title: {
                            fontSize: 20,
                            color: '#1a3856',
                            bold: true,
                            alignment: 'center'
                        },
                        cover_subtitle: {
                            fontSize: 14,
                            color: '#1a3856',
                            bold: true,
                            alignment: 'center'
                        },
                        cover_header: {
                            fontSize: 12,
                            color: '#1a3856',
                            bold: true,
                            alignment: 'center'
                        },
                        h1: {
                            fontSize: 18,
                            bold: true
                        },
                        h2: {
                            fontSize: 16,
                            bold: true
                        },
                        h2_center: {
                            fontSize: 16,
                            bold: true,
                            alignment: 'center'
                        },
                        h3: {
                            fontSize: 12,
                            bold: true,

                        },
                        h3_blue: {
                            fontSize: 12,
                            bold: true,
                            color: '#1a3856',
                        },
                        h3_lightblue: {
                            fontSize: 12,
                            bold: true,
                            color: '#0088f7'
                        },
                        h4: {
                            fontSize: 11,
                            bold: true
                        },
                        h5: {
                            fontSize: 10,
                            bold: true
                        },
                        h5_underline: {
                            fontSize: 10,
                            decoration: 'underline',
                            bold: true
                        },
                        h6: {
                            fontSize: 9,
                            bold: true
                        }
                    },
                    //header & footer
                    header: function (currentPage, pageCount, pageSize) {
                        // apply any logic and return any valid pdfmake element
                        return [
                            {
                                text: Vue.i18n.translate('Barnatasa_header'),
                                // alignment: (currentPage % 2) ? 'left' : 'right'
                                alignment: 'center',
                                margin: [0, 10],
                                style: 'header_small'
                            },
                            {
                                columns: [
                                    {
                                        width: 200,
                                        border: [false, false, false, true],
                                        text: 'BARNA-TASA, S.A.',
                                        style: 'header_title_blue',
                                        alignment: 'left',
                                        margin: [40, 0]

                                    },
                                    {
                                        width: '*',
                                        border: [false, false, false, true],
                                        text: 'EXP. ' + full_number,
                                        style: 'plain_blue',
                                        alignment: 'right',
                                        margin: [40, 0]

                                    }
                                ]
                            }
                        ]
                    },
                    footer: function (currentPage, pageCount, pageSize) {
                        // apply any logic and return any valid pdfmake element
                        return [
                            {
                                layout: 'noBorders',
                                margin: [30, 0, 30, 30],
                                table: {
                                    headerRows: 0,
                                    widths: ['*', 20],
                                    body: [
                                        [

                                            {
                                                border: [false, false, false, false],
                                                //fillColor: 'whitesmoke',
                                                text: 'Carrer de Còrsega, 168, 1º 1ª, 08036, Barcelona | NIF: A60840543 | tel. (+34) 93 410 05 32 | info@barnatasa.com ',
                                                style: 'plain_bold',
                                                alignment: 'center'
                                            },
                                            {
                                                text: currentPage + ' / ' + pageCount,
                                                //fillColor: 'whitesmoke',
                                                style: 'plain',
                                                alignment: 'right'

                                            }
                                        ]
                                    ]
                                }
                            }
                        ]
                    },
                    // content
                    content: []
                }



                // expedient
                filenumber = ''
                if (this.appraisalfile.number) {
                    filenumber = this.appraisalfile.number
                } else {

                    appraisalfile_review_table.push([
                            {
                                text: '',
                                style: 'plain_bold'
                            },
                            {
                                text: 'Manca introduir el número d\'expedient.',
                                style: 'plain',
                                alignment: 'left'
                            }
                        ]
                    )

                }

                // invoicenumber
                invoicenumber = ''
                if (this.appraisalinvoice.number) {
                    // pad, zero fill ->2
                    let s = this.appraisalinvoice.number + ''
                    while (s.length < 2) s = '0' + s
                    invoicenumber = s
                } else {
                    appraisalinvoice_review_table.push([
                            {
                                text: this.appraisalinvoice.id,
                                style: 'plain_bold'
                            },
                            {
                                text: 'Manca introduir el número de factura.',
                                style: 'plain',
                                alignment: 'left'
                            }
                        ]
                    )
                }

                // invoiceversion
                invoiceversion = ''
                if (this.appraisalinvoice.version) {
                    // pad, zero fill ->2
                    let s = this.appraisalinvoice.version + ''
                    while (s.length < 2) s = '0' + s
                    invoiceversion = s
                } else {
                    appraisalinvoice_review_table.push([
                            {
                                text: this.appraisalinvoice.id,
                                style: 'plain_bold'
                            },
                            {
                                text: 'Manca introduir la versió de la factura.',
                                style: 'plain',
                                alignment: 'left'
                            }
                        ]
                    )
                }

                docDefinition.content.push(
                    {
                        text: '',
                        margin: [0, 8],
                    },
                    {
                        image: 'data:image/png;base64,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',
                        width: 100,
                        //margin: [0, 0],
                        alignment: 'left'
                    },
                    {
                        text: Vue.i18n.translate('Invoice'),
                        margin: [10, 8],
                        style: 'h1',
                        alignment: 'right'
                    },
                    {
                        text: Vue.i18n.translate('Emmission_date') + ':  ' + moment().format('DD/MM/YYYY'),
                        margin: [10, 4],
                        style: 'plain_bold',
                        alignment: 'right'
                    },
                    {
                        text: Vue.i18n.translate('Invoice_number') + ':  ' + this.appraisalinvoice.fiscal_number,
                        margin: [10, 4],
                        style: 'plain_bold',
                        alignment: 'right'
                    },
                    {
                        text: Vue.i18n.translate('Reference') + ':  ' + this.appraisalinvoice.full_number,
                        margin: [10, 4],
                        style: 'plain_bold',
                        alignment: 'right'
                    },
                    {
                        text: '',
                        margin: [0, 8],
                        style: 'plain'
                    }
                )

                let petitioners_arr = _.values(this.appraisalinvoice_petitioners)

                petitioners_arr = _.sortBy(petitioners_arr, 'surnames')

                let currentLocale = this.currentLocale

                let columns = []

				counter = 0

                _.forEach(petitioners_arr, function (value, index) {
                    //counter = counter + 1;
					//console.log('---> counter: ')
					//console.log(counter)
					console.log(index)



                    let name = value['name'] ? value['name'] : ''
                    let surnames = value['surnames'] ? value['surnames'] : ''
                    // let address = value['full_address
                    let address = value['complete_fiscal_address'] ? value['complete_fiscal_address'] : ''
                    let tin = value['tin'] ? value['tin'] : ''
                    let email = value['main_email'] ? value['main_email'] : ''

                    let petitioner_name = name + ' ' + surnames

                    columns.push(
                        {
                            layout: 'noBorders',
                            table: {

                                headerRows: 1,
                                widths: [160],
                                margin: [0, 8],
                                body: [
                                    [

                                        {
                                            text: Vue.i18n.translate('Invoice_to') + ': ',
                                            style: 'plain_bold'
                                        },
                                    ],
                                    [

                                        {
                                            text: petitioner_name,
                                            style: 'plain'
                                        }
                                    ],
                                    [
                                        {
                                            text: 'NIF: ' + tin,
                                            style: 'plain'
                                        }
                                    ],
                                    [
                                        {
                                            text: address,
                                            style: 'plain'
                                        }
                                    ],
                                    [
                                        {
                                            text: email,
                                            style: 'plain'
                                        }
                                    ]
                                ]
                            }
                        }
                    )

                    if(index >= _.size(petitioners_arr) - 1){
					console.log('about to push column')
                        columns.push(
                            {
                                layout: 'noBorders',
                                table: {

                                    headerRows: 1,
                                    widths: [160],
                                    margin: [0, 8],
                                    body: [
                                        [

                                            {
                                                text: Vue.i18n.translate('Emited_by') + ': ',
                                                style: 'plain_bold'
                                            },
                                        ],
                                        [

                                            {
                                                text: 'BARNA-TASA, S.A.',
                                                style: 'plain'
                                            }
                                        ],
                                        [
                                            {
                                                text: 'NIF: A60840543',
                                                style: 'plain'
                                            }
                                        ],
                                        [
                                            {
                                                text: 'Carrer de Còrsega, 168, 1-1, 08036 - Barcelona',
                                                style: 'plain'
                                            }
                                        ],
                                        [
                                            {
                                                text: 'info@barnatasa.com',
                                                style: 'plain'
                                            }
                                        ]
                                    ]
                                }
                            }
                        )
                    }


                    // petitioners_emails = petitioners_emails + email

                })

                docDefinition.content.push(
                    {
                        columns: columns
                    },
                    {
                        text: '',
                        margin: [0, 20],
                    },
                )

                let line_table = {
                    layout: 'hLineWidth',
                    table: {

                        headerRows: 1,
                        widths: [320, 120, 60],
                        margin: [0, 8],
                        body: [
                            [

                                {
                                    text: Vue.i18n.translate('Concept'),
                                    style: 'plain_bold',
                                    border: [false, false, false, true]
                                },
                                {
                                    text: Vue.i18n.translate('Cadastral_reference'),
                                    style: 'plain_bold',
                                    border: [false, false, false, true]
                                },
                                {
                                    text: Vue.i18n.translate('Amount_money'),
                                    style: 'plain_bold',
                                    border: [false, false, false, true]
                                }
                            ]
                        ]
                    }

                }

                let counter = 0

				let endlineborder = [false, true, false, false]
				let noborder = [false, false, false, false]
				let linessize = _.size(this.appraisalinvoice_lines)

				let fprice = this.appraisalinvoice.final_price

                _.forEach(this.appraisalinvoice_lines, function (value) {
                    counter = +1

					let border = noborder
					if(counter > linessize-1){
					    border = endlineborder
                    }

                    console.log('**** --- >')
                    console.log(value)

                    let type = ''
                    if (value.property_type) {
                        if (tempCurrentLocale() === 'ca') {
                            type = value.property_type.usage_type_ca
                        } else if (tempCurrentLocale() === 'en') {
                            type = value.property_type.usage_type_en
                        } else {
                            type = value.property_type.usage_type_es
                        }
                    } else {

                        line_review_table.push([
                                {
                                    text: Vue.i18n.translate('Line') + ' nº ' + (counter + 1).toString(),
                                    style: 'plain_bold'
                                },
                                {
                                    text: 'Manca introduir el tipus d\'immoble',
                                    style: 'plain',
                                    alignment: 'left'
                                }
                            ]
                        )

                    }

                    let desc = value.description ? value.description : ' '
					let cadref = value.cadastral_reference? value.cadastral_reference : ' '
					let qprice = value.quote_price_incl_travel_expenses? tempNumFormat(value.quote_price_incl_travel_expenses, '€') : fprice ? fprice : ' '

                    line_table['table']['body'].push(
                        //// PAGE-BREAK
                        [

                            {
                                text: '- ' + desc,
                                style: 'plain',
                                border: border
                            },
                            {
                                text: cadref,
                                style: 'plain',
                                border: border
                            },
                            {
                                text: qprice,
                                style: 'plain',
                                border: border
                            }
                        ]
                    )

                    total_invoice_fees_without_vat = value.quote_price_incl_travel_expenses? total_invoice_fees_without_vat + value.quote_price_incl_travel_expenses : fprice? fprice : ' '

                })

                docDefinition.content.push(
                    //// PAGE-BREAK
                    line_table
                )

                // final_price includes the discount, but not yet the VAT
                let final_price = 0
                if (this.appraisalinvoice.final_price) {
                    final_price = this.appraisalinvoice.final_price
                }

                invoice_vat = this.roundToTwo(final_price * (this.appraisalinvoice.vat_pct / 100))

                total_invoice_fees_incl_vat = final_price + invoice_vat

                docDefinition.content.push(
                    {
                        text: '',
                        margin: [0, 10],
                    },
                    {
                        text: Vue.i18n.translate('Fees') + ': ' + this.numFormat(total_invoice_fees_without_vat, '€'),
                        margin: [15, 4],
                        style: 'plain_bold',
                        alignment: 'right'
                    }
                )
                if (this.appraisalinvoice.discount_pct && this.appraisalinvoice.discount_pct > 0) {
                    docDefinition.content.push(
                        {
                            text: Vue.i18n.translate('Discount') + '* (' + this.appraisalinvoice.discount_pct + '%): ' + this.numFormat(final_price - total_invoice_fees_without_vat, '€'),
                            margin: [15, 4],
                            style: 'plain_green_bold',
                            alignment: 'right'
                        },
                        {
                            text: '',
                            margin: [15, 4],
                        },
                        {
                            text: Vue.i18n.translate('Fees_incl_discount') + ': ' + this.numFormat(final_price, '€'),
                            margin: [15, 4],
                            style: 'plain_bold',
                            alignment: 'right'
                        }
                    )

                }

                docDefinition.content.push(
                    {
                        text: Vue.i18n.translate('VAT') + ' (' + this.appraisalinvoice.vat_pct + '%): ' + this.numFormat(invoice_vat, '€'),
                        margin: [15, 4],
                        style: 'plain_bold',
                        alignment: 'right'
                    },
                    {
                        text: Vue.i18n.translate('Invoice_Total') + ': ' + this.numFormat(total_invoice_fees_incl_vat, '€'),
                        margin: [15, 12],
                        style: 'h3_blue',
                        alignment: 'right'
                    },
                    {
                        text: '',
                        margin: [15, 10],
                    })

                if (this.appraisalinvoice.discount_pct && this.appraisalinvoice.discount_pct > 0 && this.appraisalinvoice.discount_notes) {
                    docDefinition.content.push(
                        {
                            text: '* ' + this.appraisalinvoice.discount_notes,
                            margin: [15, 4],
                            style: 'plain',
                            alignment: 'left'
                        },
                        {
                            text: '',
                            margin: [15, 4],
                        }
                    )

                }

                let s_name = this.appraisalinvoice.signature_name? this.appraisalinvoice.signature_name : ''

                docDefinition.content.push(

                    {
                        image: this.appraisalinvoice.signature_base64 ? this.appraisalinvoice.signature_base64: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAABAAEDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9/KKKKAP/2Q==',
                        width: 164,
                        margin: [0, 0]
                    },
                    {
                        text: s_name,
                        margin: [0, 0],
                        style: 'plain',
                    },
                    {
                        text: 'BARNA-TASA, S.A.',
                        margin: [0, 0],
                        style: 'plain_bold',
                    },
                    {
                        text: '',
                        margin: [0, 10],
                    },
                    {
                        text: Vue.i18n.translate('Quote_sentence_03') + ' (' + this.appraisalinvoice.bank_name + '): ',
                        margin: [0, 4],
                        style: 'plain',
                    },
                    {
                        text: 'IBAN ' + this.appraisalinvoice.iban,
                        margin: [0, 4],
                        style: 'plain_bold',
                    }
                )

                //////// Check empty review tables

                let no_error_text = 'Sense errors detectats.'

                if (line_review_table.length === 0) {

                    line_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]]
                }

                if (comparable_review_table.length === 0) {

                    comparable_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]]
                }

                if (marketstudy_review_table.length === 0) {

                    marketstudy_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]]
                }

                if (appraisal_review_table.length === 0) {

                    appraisal_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]]
                }

                if (appraisalfile_review_table.length === 0) {

                    appraisalfile_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]]

                }

                if (appraisalinvoice_review_table.length === 0) {

                    appraisalinvoice_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]]

                }

                //////// End of check empty review tables

                let reviewDocDefinition = {
                    // settings
                    pageSize: 'A4',
                    pageOrientation: 'portrait',
                    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                    pageMargins: [40, 60, 20, 20],
                    // metadata
                    info: {
                        title: 'BARNA-TASA, S.A.',
                        author: 'BARNA-TASA, S.A.',
                        subject: 'BARNA-TASA, S.A.',
                        keywords: 'BARNA-TASA, S.A.',
                        creator: 'BARNA-TASA, S.A.',
                        producer: 'BARNA-TASA, S.A.'
                    },
                    styles: {
                        small: {
                            fontSize: 8,
                            bold: false
                        },
                        small_bold: {
                            fontSize: 8,
                            bold: true
                        },
                        plain: {
                            fontSize: 9,
                            bold: false
                        },
                        plain_bold: {
                            fontSize: 9,
                            bold: true
                        },
                        h2: {
                            fontSize: 16,
                            bold: true
                        },
                        h3: {
                            fontSize: 12,
                            bold: true
                        }
                    },
                    // content
                    content: [
                        {
                            text: 'Informe automàtic de revisió de Factura ' + full_number,
                            style: 'h2'
                        },
                        {
                            text: '',
                            margin: [0, 15],
                        },
                        //// END OF BLOCK
                        //// BLOCK START
                        {
                            text: '',
                            margin: [0, 10],
                        },
                        {
                            text: 'Expedient:',
                            style: 'h3',
                        },
                        {
                            text: '',
                            margin: [0, 5],
                        },
                        {
                            layout: 'noBorders',
                            margin: [50, 0],
                            table: {

                                headerRows: 0,
                                widths: [160, '*'],
                                body: appraisalfile_review_table
                            }
                        },
                        //// END OF BLOCK
                        //// BLOCK START
                        {
                            text: '',
                            margin: [0, 10],
                        },
                        {
                            text: 'Factura:',
                            style: 'h3',
                        },
                        {
                            text: '',
                            margin: [0, 5],
                        },
                        {
                            layout: 'noBorders',
                            margin: [50, 0],
                            table: {

                                headerRows: 0,
                                widths: [160, '*'],
                                body: appraisalinvoice_review_table
                            }
                        },
                        //// END OF BLOCK
                        //// BLOCK START
                        {
                            text: '',
                            margin: [0, 10],
                        },
                        {
                            text: 'Línies de factura:',
                            style: 'h3',
                        },
                        {
                            text: '',
                            margin: [0, 5],
                        },
                        {
                            layout: 'noBorders',
                            margin: [50, 0],
                            table: {

                                headerRows: 0,
                                widths: [160, '*'],
                                body: line_review_table
                            }
                        },

                        //// END OF BLOCK

                    ]
                }

                pdfMake.createPdf(docDefinition).open()
                pdfMake.createPdf(reviewDocDefinition).open()
                // pdfMake.createPdf(docDefinition).download()
                console.log('yeah finished!')
                this.master_loading = false

            },
            onSaveCurrentAppraisalInvoice: function (data) {
                this.UPDATE_APPRAISALINVOICE({
                    object: this.appraisalinvoice,
                    path: this.appraisalinvoice.path,
                    parent_path: this.appraisalinvoice.parent_path,
                    key: this.appraisalinvoice.id
                }).then((res) => {
                    // router.go(-1)
                    if (data.go_up) {
                        this.onGoUp()
                    }
                })
            }
            ,
            editLine: function (entity) {
                // console.log('edit line...')
                this.SET_LINE({path: 'lines' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'line-editor', query: {id: entity.id}})

                })
            }
            ,
            deleteLine: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete') + ' ' + Vue.i18n.translate('line') + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_LINE({
                        path: 'lines' + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'appraisalinvoices' + '/' + this.appraisalinvoice.id + '/' + 'lines' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISALINVOICE_LINES({path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'lines' + '/'})
                            .then(() => {
                                this.calc_final_price()
                                this.master_loading = false
                            })
                    })

                }

            }
            ,
            editContact: function (entity) {
                // console.log('edit realestate...')
                this.SET_CONTACT({path: 'contacts' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'contact-editor', query: {id: entity.id}})

                })
            },
            discardPetitioner: function (entity) {
                this.master_loading = true

                this.DELETE({
                    path: 'appraisalinvoices' + '/' + this.appraisalinvoice.id + '/' + 'petitioners' + '/' + entity.id,
                    key: entity.id
                }).then((res) => {

                    this.DELETE({
                        path: 'contacts' + '/' + entity.id + '/' + 'appraisalinvoices' + '/' + this.appraisalinvoice.id,
                        key: entity.id
                    }).then((res) => {

                        this.FETCH_APPRAISALINVOICE_PETITIONERS({path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'petitioners' + '/'})
                            .then(() => {
                                this.master_loading = false
                            })

                    })
                })

            },
            onGoBack: function () {
                router.go(-1)
            }
            ,
            onGoUp: function () {
                this.$router.push({name: 'appraisalfile-editor', query: {id: this.appraisalinvoice.file_id}})
            }
        },
        head: {
            title: {
                inner: 'Edit appraisalinvoice'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// AppraisalInvoiceEditor.vue?705669c8